<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        x-small
        color="primary"
        class="mr-2"
        @click.stop="uploadModal(item)"
      >
        <v-icon small>
          mdi-file-upload-outline
        </v-icon>
      </v-btn>
    </template>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card>
        <v-card-title class="headline">
          {{ $t("uploadModal.fileUpload") }} - {{ $t("device") }}
          {{ editedItem.id }}
        </v-card-title>

        <v-card-text>
          <v-file-input
            :rules="rules"
            v-model="upload"
            accept=".bin"
            chips
            outlined
            dense
            color="primary"
            prepend-icon="mdi-file-upload"
            :label="$t('uploadModal.fileUpload')"
          ></v-file-input>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :loading="btnLoading"
            :disabled="!upload || btnLoading"
            color="primary"
            depressed
            outlined
            @click="uploadFirmware()"
          >
            {{ $t("upload") }}
          </v-btn>
          <v-btn color="primary" text @click="close">
            {{ $t("close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  props: ["item", "auth"],
  data() {
    return {
      upload: null,
      valid: true,
      rules: [
        (v) => !!v || this.$i18n.t("uploadModal.uploadSelectText"),
        (value) =>
          !value ||
          value.size < 5000000 ||
          this.$i18n.t("uploadModal.uploadSelectError"),
      ],
      dialog: false,
      btnLoading: false,
      editedItem: {},
    };
  },
  methods: {
    async uploadFirmware() {
      this.btnLoading = true;
      try {
        if (this.$refs.form.validate()) {
          const payload = {
            file: this.upload,
            name: this.upload.name,
            id: String(this.editedItem.id),
            host: this.auth.host,
            secret: this.auth.secret,
          };
          await this.$store.dispatch("uploadFirmware", payload);
          this.upload = null;
          this.dialog = false;
          this.btnLoading = false;
        }
      } catch {
        this.upload = null;
        this.dialog = false;
        this.btnLoading = false;
      }
    },

    uploadModal(item) {
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.upload = null;
      this.dialog = false;
    },
  },
};
</script>
